import { setFlashMessage } from '@engine/actions/creators/flash-message';
export function requestExport(url) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  return function (dispatch) {
    return fetch(url, {
      method: method,
      headers: {
        contentType: 'application/json;',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': window.CSRF
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(setFlashMessage({
        status: json.status,
        content: json.message
      }));
    })["catch"](function () {
      return dispatch(setFlashMessage({
        status: 'danger',
        content: I18n.t('javascript.errors.something_went_wrong')
      }));
    });
  };
}